module.exports = __webpack_public_path__ + "static/media/grant_compliance.27801b3a.svg";